// extracted by mini-css-extract-plugin
export default {"text":"Favorites_text__k8lVp"};